// extracted by mini-css-extract-plugin
export var orderSummary = "_qg-0";
export var showMoreLessButton = "_qg-1";